export const FIELD = {
	name: 'name',
	firstName: 'firstName',
	lastName: 'lastName',
	email: 'email',
	description: 'description',
	password: 'password',
	confirmPassword: 'confirmPassword',
	checkbox: 'checkbox',
	address: 'address',
	number: 'number',
	taxIdNumber: 'taxIdNumber',
	image: 'image',
	userName: 'userName',
	role: 'role',
	emailForPassword: 'emailForPassword',
	goalAmount: 'goalAmount',
	isGoalAmount: 'isGoalAmount',
	logo: 'logo',
	location: 'location',
	startDate: 'startDate',
	endDate: 'endDate',
	startTime: 'startTime',
	endTime: 'endTime',
	sponsors: 'sponsors',
	ticketsSalesStartDate: 'ticketsSalesStartDate',
	ticketsSalesStartTime: 'ticketsSalesStartTime',
	ticketsSalesEndDate: 'ticketsSalesEndDate',
	ticketsSalesEndTime: 'ticketsSalesEndTime',
	tableInfos: 'tableInfos',
	customizeWebpage: 'customizeWebpage',
	primaryColor: 'primaryColor',
	webpageLogo: 'webpageLogo',
	isOnlineAuction: 'isOnlineAuction',
	isFundTheMission: 'isFundTheMission',
	isRaffle: 'isRaffle',
	startAuctionDate: 'startAuctionDate',
	startAuctionTime: 'startAuctionTime',
	endAuctionDate: 'endAuctionDate',
	endAuctionTime: 'endAuctionTime',
	startRaffleDate: 'startRaffleDate',
	startRaffleTime: 'startRaffleTime',
	endRaffleDate: 'endRaffleDate',
	endRaffleTime: 'endRaffleTime',
	prizeLogo: 'prizeLogo',
	raffleDescription: 'raffleDescription',
	price: 'price',
	quantity: 'quantity',
	setTables: 'setTables',
	isCoverFree: 'isCoverFee',
	paymentOption: 'paymentOption',
	phoneNumber: 'phoneNumber',
	meals: 'meals',
	purchaserIsNotAttending: 'purchaserIsNotAttending',
	isVIP: 'isVIP',
	photos: 'photos',
	isLiveAuction: 'isLiveAuction',
	categoryId: 'categoryId',
	value: 'value',
	minBid: 'minBid',
	bidIncrement: 'bidIncrement',
	buyNowPrice: 'buyNowPrice',
	donors: 'donors',
	images: 'images',
	city: 'city',
	state: 'state',
	zip: 'zip',
	organizationName: 'organizationName',
	organizationAddress: 'organizationAddress',
	isUnknown: 'isUnknown',
};

export const FIELD_LABEL = {
	firstName: 'First Name',
	lastName: 'Last Name',
	userName: 'User Name',
	email: 'Email',
	role: 'Role',
	emailForPassword: 'Send login credentials to email',
	password: 'Password',
	confirmPassword: 'Confirm Password',
	organizationName: 'Organization Name',
	organizationAddress: 'Organization Address',
	taxIdNumber: 'Tax ID Number',
	eventName: 'Event name',
	goalAmount: 'Fundraising goal (optional)',
	eventDescription: 'Event description',
	eventLogoOrImage: 'Event logo or image',
	eventLocation: 'Event location',
	eventStartDate: 'Event start date',
	startDate: 'Start date',
	startTime: 'Start time',
	eventEndDate: 'Event end date',
	startAuctionDate: 'Start auction date',
	endAuctionDate: 'End auction date',
	startRaffleDate: 'Start raffle date',
	endRaffleDate: 'End raffle date',
	endDate: 'End date',
	endTime: 'End time',
	sponsorLogo: 'Sponsor logo',
	sponsorName: 'Sponsor name',
	sponsorCategory: 'Sponsor category',
	ticketsTier: 'Table or Ticket Name ',
	numberOfSeats: 'Seats/Tbl/Tkt',
	amountOfTickets: 'Amount Of Tickets',
	price: 'Price',
	customizeWebpage: 'Customize event webpage',
	primaryColor: 'Primary color',
	logo: 'Logo',
	prizeLogo: 'Raffle prize photo',
	raffleDescription: 'Raffle description',
	ticketsQuantity: 'Tickets quantity',
	ticketPrice: 'Ticket price',
	phoneNumber: 'Phone Number',
	phone: 'Phone',
	meals: 'Choose special meal',
	tableName: 'Table Name',
	itemDescription: 'Item Description',
	itemName: 'Item name',
	category: 'Category',
	value: 'Value',
	minBid: 'Min bid',
	bidIncrement: 'Bid Increment',
	buyNowPrice: 'Buy Now Price',
	donorName: 'Donor Name',
	donorLogo: 'Donor Logo',
	address: 'Address',
	city: 'City',
	state: 'State',
	zip: 'Zip',
	meal: 'Meal',
	name: 'Name',
	numberOfTables: 'Qty for Sale',
	ticketsQuantityRaffle: 'Tickets quantity (leave blank for unlimited)',
	tickets: 'Tickets',
	fairMarketValue: 'Fair Market Val.',
};

export const PLACEHOLDER = {
	firstName: 'Enter your first name',
	enterFirstName: 'Enter first name',
	lastName: 'Enter your last name',
	enterLastName: 'Enter last name',
	email: 'email@example.mail.com',
	emailEnter: 'Enter email',
	password: 'Enter your password',
	enterPassword: 'Enter password',
	confirmPassword: 'Confirm your password',
	organizationName: 'Enter organization’s name',
	organizationAddress: 'Enter organization address',
	taxIdNumber: 'Enter tax ID',
	address: 'Enter address',
	city: 'Enter city',
	state: 'Enter state',
	zip: 'Enter zip code',
	userName: 'Enter user name',
	enterEmail: 'Enter email',
	eventName: 'Enter the name of your event',
	itemName: 'Enter item name',
	eventDescription: 'Add a short description guests will see on your event page',
	eventLocation: 'Enter venue name or address',
	zero: '0',
	sponsorName: 'Enter sponsor name',
	sponsorCategory: 'Enter sponsor category',
	ticketsTier: 'Enter tickets/table name',
	customizeWebpage: 'eventsimpli.com/event',
	raffleDescription: 'Enter raffle description',
	itemDescription: 'Enter item description',
	phoneNumberZero: '000 000-0000',
	phoneNumber: 'Enter phone number',
	tableName: 'Enter table name',
	tableNameOrCompany: 'Enter table name (company or host name)',
	donorName: 'Enter donor name',
	adminName: 'Enter admin name',
	raffle: 'Raffle description',
	unlimited: 'Unlimited',
	price: 'Enter price',
	
};
